var e = { icon: { tag: "svg", attrs: { viewBox: "0 0 100 100", focusable: "false", fill: "currentColor" }, children: [{ tag: "path", attrs: { d: "M40.04 47.84L89.48 0l7.62 7.55-41.86 40.6 42.02 44.6-8.19 7.25-49.03-52.16zm19.92 44.91L51.78 100 2.74 47.84 52.2 0l7.61 7.55-41.85 40.6 42.01 44.6z", "fill-rule": "nonzero" } }] }, name: "prev", theme: "filled" };
export {
  e as default
};
